import { Component, inject } from '@angular/core';
import { UIService } from '@core/ui/ui.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipDirective } from '@shared/directives/tooltip/tooltip.directive';

@Component({
  selector: 'app-navigation-bar-toggle',
  imports: [FontAwesomeModule, TooltipDirective],
  templateUrl: './navigation-bar-toggle.component.html',
  styleUrl: './navigation-bar-toggle.component.scss',
})
export class NavigationBarToggleComponent {

    uiService = inject(UIService);
    
    isNavBarExpanded = this.uiService.isNavBarExpanded;
    
    toggleNav(){
        this.uiService.toggleNavBarState();
    }
}
